import { bindActionCreators } from '@reduxjs/toolkit';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { all, getListHits } from '../../actions/list';
import OverflowGrid from '../../components/overflow-grid';
import type { RootState } from '../../reducers';
import { getList } from '../../selectors/list';
import SelectedCategory from './selected-category';

const SelectedCategories = () => {
  const { t } = useTranslation('startpage');
  const dispatch = useDispatch();

  const list = useSelector(getList);
  const hits = useSelector<RootState>((s) => s.list.hits);

  const actions = bindActionCreators(
    {
      all,
      getListHits,
    },
    dispatch,
  );

  useEffect(() => {
    if (!list.length) actions.all();
    if (!hits) actions.getListHits();
  }, []);

  if (!list.length) {
    return null;
  }

  return (
    <section className="page-section" aria-label="Kategorier">
      <div data-wx-listsection="">
        <div className="list-section-heading">
          <div data-wx-label="" className="m-b-half">
            {t('Categories', { ns: 'startpage' })}
          </div>
          <h2 className="h5 no-margin">{t('Search by category', { ns: 'startpage' })}</h2>
        </div>
        <div className="list-section-content">
          <OverflowGrid visibleItems={6} modifiers="overflow-small">
            {list.map((listItem, i) => (
              <SelectedCategory key={listItem.id} listItem={listItem} index={i} />
            ))}
          </OverflowGrid>
        </div>
      </div>
    </section>
  );
};

export default SelectedCategories;
